export function getAllAgreements(axiosPrivate) {
  return axiosPrivate.get('/trade-data-agreement/list-agreements')
}

export function getOptionAgreements(axiosPrivate) {
  return axiosPrivate.get('/trade-data-agreement/options')
}

export function getChapterReviewById(axiosPrivate, params) {
  const id = params.idReview
  return axiosPrivate.get(`/trade-data-agreement/review-chapter/${id}`)
}

export function postChapterReview(axiosPrivate, id, body) {
  return axiosPrivate.post(`/trade-data-agreement/review-chapter/${id}`, body)
}

export function deleteChapterReview(axiosPrivate, id) {
  return axiosPrivate.delete(`/trade-data-agreement/review-chapter/${id}`)
}
